import { Box, Input } from "@chakra-ui/react"
import { addDays } from "date-fns"
import React, { useState, forwardRef } from "react"

import DatePicker from "react-datepicker"
import { InputWrapper } from "./input"

const DatePicjker = ({
  startDate,
  endDate,
  setDateRange,
}: {
  startDate: any
  endDate: any
  setDateRange: (_d: any) => void
}) => {
  const ExampleCustomInput = forwardRef((props: any, ref: any) => {
    return (
      <>
        <Box my={4} width="100%" maxWidth="400px" minWidth="250px">
          <InputWrapper title="Select date range">
            <Input
              onClick={props?.onClick}
              ref={ref}
              value={props?.value}
              placeholder="DD-MM-YYYY - DD-MM-YYYY"
              onChange={(e) => {}}
            />
          </InputWrapper>
        </Box>
      </>
    );
  });

  return (
    <>
      <DatePicker
        dateFormat="dd-MM-yyyy"
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        onChange={(update: any) => {
          setDateRange(update);
        }}
        customInput={<ExampleCustomInput />}
      />
    </>
  );
}

export default DatePicjker

export const SingleDatePicker = ({
  startDate,
  setDateRange,
}: {
  startDate: any
  setDateRange: (_d: any) => void
}) => {
  const ExampleCustomInput = forwardRef((props: any, ref: any) => {
    return (
      <>
        <Box my={4} width="100%">
          <InputWrapper title="Select date">
            <Input
              onClick={props?.onClick}
              ref={ref}
              value={props?.value}
              placeholder="DD/MM/YYYY"
              onChange={(e) => {}}
            />
          </InputWrapper>
        </Box>
      </>
    )
  })

  return (
    <>
      <DatePicker
        dateFormat="dd/MM/yyyy"
        selected={startDate}
        onChange={(update: any) => {
          console.log(update)
          setDateRange(update)
        }}
        customInput={<ExampleCustomInput />}
      />
    </>
  )
}
